import { defaultClient } from '@api/client';

export const deletePostImage = ({ id }) => {
  return defaultClient.delete(`/postImages/${id}`);
};
